import Icon from "app/components/UI/Icon";
import Input from "app/components/UI/Input";
import PropTypes from "prop-types";
import React from "react";
import classes from "./Input.module.css";

const InputWithIcon = ({ icon, ...props }) =>
  <div className={classes.input__relative}>
    <Input className={classes.input__withIcon} {...props} />

    <Icon className={classes.icon}>
      {icon}
    </Icon>
  </div>;

InputWithIcon.propTypes = {
  icon: PropTypes.string.isRequired
};

export default InputWithIcon;



// WEBPACK FOOTER //
// ./src/app/components/UI/Input/InputWithIcon.js